import React, { FunctionComponent, useEffect } from 'react';
import { useParams, Redirect, useHistory } from 'react-router-dom';
import SignOnPage from '../../pages/sign-in/sign-in';
import NotFoundPage from '../../pages/not-found-page/not-found-page';
import { getPresenterLinkPath } from '../../utils/helpers/api-helpers';
import { useStore } from '../../store/store-provider';
import { Loader } from '../../components';
import { authService } from '../../utils/services/auth-service';
import { observer } from 'mobx-react';
import { getDefaultRoutePathByPermissions } from '../../utils/helpers/features-routes-helpers';

interface IRouteParams {
    id: string;
}

const LoginPageWrapper: FunctionComponent = observer((): JSX.Element => {
  const { authStore, podiumInfoStore, permissionsStore } = useStore();
  const { autoLoginUserCall, isLoginWithoutAuth } = authStore;
  const { isLoading, isGetPresentationInfoSuccess } = podiumInfoStore;

  const { envPath: presenterLink, urlPath, urlHash } = getPresenterLinkPath();
  const { id } = useParams<IRouteParams>();
  const history = useHistory();

  const renderAuthPage = (): JSX.Element => {
    const path = getDefaultRoutePathByPermissions(permissionsStore);
    return (
      authService.isAuth(id) || isLoginWithoutAuth ?
        <Redirect to={`${urlPath}${path}`}/> :
        <SignOnPage embedId={id}/>
    );
  };

  const redirectCallback = () => history.push('404');

  const renderOnGetPresentationInfo = (): JSX.Element => {
    return isGetPresentationInfoSuccess ? renderAuthPage() : <NotFoundPage/>;
  };

  useEffect(() => {
    if (!isLoading) return;
    autoLoginUserCall(id, presenterLink, urlHash, redirectCallback);
  }, []);

  return isLoading ? <Loader/> : renderOnGetPresentationInfo();
});

export default LoginPageWrapper;

